import { Pipe, PipeTransform } from '@angular/core';
import { utcToZonedTime } from 'date-fns-tz';

@Pipe({
  name: 'toLocalTime',
  standalone: true,
})
export class ToLocalTimePipe implements PipeTransform {
  transform(
    dateString: string,
    timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
  ): Date {
    const isUtc = dateString.endsWith('Z');
    const utcDateString = isUtc ? dateString : `${dateString}Z`;
    const zonedTime = utcToZonedTime(utcDateString, timezone);
    return zonedTime;
  }
}
